<template>
  <section class="evento-lux">

    <!-- ===== TARJETA 1: CEREMONIA ===== -->
    <article
      ref="card1"
      class="card"
      aria-label="Ceremonia"
    >

      <img
        class="icono1"
        src="@/assets/ChatGPT Image 24 may 2026, 12_32_35 p.m..png"
        alt=""
      />

      <h3 class="titulo-script">
        Ceremonia
      </h3>

      <p class="hora">
        2:30 PM
      </p>

      <p class="lugar">
        Centro Cristiano Bethel
      </p>

      <p class="direccion">
        3600 W Vegas Dr <br>
        Las Vegas, Nevada.
      </p>

      <a
        ref="btn1"
        class="btn-rosa"
        href="https://maps.app.goo.gl/DPmoEov4a5PsBXEA7"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>

    </article>

    <!-- ===== TARJETA 2: CELEBRACIÓN ===== -->
    <article
      ref="card2"
      class="card"
      aria-label="Celebración"
    >

      <img
        class="icono"
        src="@/assets/coroa.png"
        alt=""
      />

      <h3 class="titulo-script">
        Celebración
      </h3>

      <p class="hora">
        5:00 PM
      </p>

      <p class="lugar">
        Chandelier Banquet Hall
      </p>

      <p class="direccion">
        320 S Decatur Blvd <br>
        Las Vegas, Nevada.
      </p>

      <a
        ref="btn2"
        class="btn-rosa"
        href="https://maps.app.goo.gl/3e5sTrj81iaZR6t66"
        target="_blank"
        rel="noopener"
      >
        ¿Cómo llegar?
        <span class="sheen"></span>
      </a>

    </article>

  </section>
</template>
<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {

  name: 'BienvenidaPage',

  setup() {

    const mensaje = ref('');

    // FECHA
    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);

    // TEXTO
    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);

    // ✨ NUEVO
    const versiculoFinalRef = ref(null);

    // FLORES
    const disco1Ref = ref(null);
    const disco2Ref = ref(null);
    const disco3Ref = ref(null);

    // RAMAS
    const rama1Ref = ref(null);
    const rama2Ref = ref(null);

    const animateOnScroll = (el, animationFn) => {

      if (!el) return;

      const observer = new IntersectionObserver(

        ([entry]) => {

          if (entry.isIntersecting) {

            animationFn();

            observer.unobserve(el);

          }

        },

        {
          threshold: 0.3
        }

      );

      observer.observe(el);

    };

    onMounted(() => {

      // ✨ TIMELINE GENERAL
      const iniciarAnimacion = () => {

        const tl = gsap.timeline({

          defaults: {
            ease: 'power2.out'
          }

        });

        // SAVE THE DATE
        tl.fromTo(

          granDiaRef.value,

          {
            opacity: 0,
            y: 40
          },

          {
            opacity: 1,
            y: 0,
            duration: 0.8
          }

        )

        // DOMINGO
        .fromTo(

          diaSemanaRef.value,

          {
            opacity: 0,
            y: 25
          },

          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },

          '-=0.4'

        )

        // NÚMERO
        .fromTo(

          numeroRef.value,

          {
            opacity: 0,
            scale: 0.5,
            y: -80,
            rotate: -8
          },

          {
            opacity: 1,
            scale: 1,
            y: 0,
            rotate: 0,
            duration: 1,
            ease: 'back.out(1.7)'
          },

          '-=0.2'

        )

        // MES
        .fromTo(

          mesRef.value,

          {
            opacity: 0,
            y: 20
          },

          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },

          '-=0.5'

        )

        // AÑO
        .fromTo(

          anioRef.value,

          {
            opacity: 0,
            y: 20
          },

          {
            opacity: 1,
            y: 0,
            duration: 0.6
          },

          '-=0.45'

        )

        // MENSAJE
        .fromTo(

          mensajeRef.value,

          {
            opacity: 0,
            y: 50
          },

          {
            opacity: 1,
            y: 0,
            duration: 1
          },

          '-=0.2'

        )

        // TEXTO PRINCIPAL
        .fromTo(

          versiculoTextRef.value,

          {
            opacity: 0,
            y: 40,
            filter: 'blur(10px)'
          },

          {
            opacity: 1,
            y: 0,
            filter: 'blur(0px)',
            duration: 1.2
          },

          '-=0.5'

        )

        // ✨ VERSÍCULO FINAL
        .fromTo(

          versiculoFinalRef.value,

          {
            opacity: 0,
            y: 35,
            scale: 0.95,
            filter: 'blur(10px)'
          },

          {
            opacity: 1,
            y: 0,
            scale: 1,
            filter: 'blur(0px)',
            duration: 1,
            ease: 'power3.out'
          },

          '-=0.3'

        )

        // ✨ FLOR 1
        .fromTo(

          disco1Ref.value,

          {
            opacity: 0,
            rotate: -20,
            scale: 0.4
          },

          {
            opacity: 1,
            rotate: 0,
            scale: 1,
            duration: 1,
            ease: "back.out(1.7)"
          },

          '-=1'

        )

        // ✨ RAMA 1
        .fromTo(

          rama1Ref.value,

          {
            opacity: 0,
            scale: 0,
            transformOrigin: "center center"
          },

          {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: "elastic.out(1, 0.5)"
          },

          '-=0.8'

        )

        // ✨ FLOR 2
        .fromTo(

          disco2Ref.value,

          {
            opacity: 0,
            rotate: 20,
            scale: 0.4
          },

          {
            opacity: 1,
            rotate: 0,
            scale: 1,
            duration: 1,
            ease: "back.out(1.7)"
          },

          '-=1'

        )

        // ✨ RAMA 2
        .fromTo(

          rama2Ref.value,

          {
            opacity: 0,
            scale: 0,
            transformOrigin: "center center"
          },

          {
            opacity: 1,
            scale: 1,
            duration: 1.2,
            ease: "elastic.out(1, 0.5)"
          },

          '-=0.8'

        )

        // ✨ FLOR 3
        .fromTo(

          disco3Ref.value,

          {
            opacity: 0,
            scale: 0.4,
            rotate: -10
          },

          {
            opacity: 1,
            scale: 1,
            rotate: 0,
            duration: 1,
            ease: "back.out(1.7)"
          },

          '-=1'

        );

      };

      animateOnScroll(
        granDiaRef.value,
        iniciarAnimacion
      );

    });

    return {

      mensaje,

      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef,

      mensajeRef,
      versiculoTextRef,
      versiculoRef,

      versiculoFinalRef,

      disco1Ref,
      disco2Ref,
      disco3Ref,

      rama1Ref,
      rama2Ref

    };

  }

};
</script>

<style scoped>
/* ==================== ssssssssBASE ELEGANTE ==================== */
:root{
  --rosa: #f4c6cc;
  --rosa-alt: #f0c3e3;
  --tinta: #141414;
  --gris: #5a5858;
  --borde: #e8e4e4;
}

.evento-lux{
  min-height: 100%;
  padding: 8px 18px 4px;
    margin-top:-70px;

   background: #d6cabd;
  display: grid;
  gap: 22px;
  place-items: center;
}

/* ==================== TARJETA ==================== */
.card{
  width: min(440px, 92vw);
  border: 1px solid var(--borde);
  border-radius: 18px;
  padding: 24px 20px 28px;
    margin-bottom: 50px;          /* pequeño respiro respecto a la tarjeta */

  background: #d6cabd;
  text-align: center;
}
.icono1{
  width: 162px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}
/* Icono discreto */
.icono{
  width: 122px; height:auto; display:block; margin: 0 auto 10px;
  filter: drop-shadow(0 1px 0 rgba(0,0,0,.05));
  opacity: .92;
}

/* Tipos (usa tus fuentes ya cargadas) */
.titulo-script {
  font-family: 'CynthiaJuneJF', cursive;
  font-weight: 400;
  font-size: 66px;
  letter-spacing: .4px;
  margin: 4px 0 8px;

  /* --- EFECTO DORADO MÁGICO --- */
  background: linear-gradient(
    110deg,
    #a67c00 30%,   /* Oro profundo */
    #bf953f 45%,   /* Oro medio */
    #ffffff 50%,   /* Reflejo de luz central */
    #bf953f 55%,   /* Oro medio */
    #a67c00 70%    /* Oro profundo */
  );
  
  background-size: 200% auto;
  -webkit-background-clip: text; /* Recorta el fondo al texto */
  background-clip: text;
  color: transparent;           /* Hace el texto transparente para ver el fondo */

  /* Sombra suave para dar relieve metálico */
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  
  /* Suavizado para fuentes cursivas largas */
  -webkit-font-smoothing: antialiased;
  display: block; 
}
.hora{
  font-family: 'fa', sans-serif;
  font-size: 24px;
  color: var(--tinta);
  margin: 0 0 6px;
}
.lugar{
  font-family: 'padres', serif;
  font-size: 22px;
  color: #000;
  font-weight: 500;
  margin: 0 0 10px;
  letter-spacing: .14em;
}
.direccion{
  font-family: 'padres', serif;
  font-style: italic;
  color: var(--gris);
  font-size: 17px;
  line-height: 1.5;
  margin: 0 auto 16px;
  max-width: 90%;
}
/* ==================== BOTÓN DORADO (CON IMAGEN) ==================== */
.btn-rosa {
  /* Aseguramos que sea visible para GSAP */
  display: flex !important; 
  position: relative;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  border-radius: 14px;

  /* Imagen Dorada */
  background-image: url('@/assets/dorado.jpeg');
  background-size: cover;
  background-position: center;
  background-color: #bf953f; /* Respaldo */

  /* Texto */
  color: #1a1a1a !important;
  -webkit-text-fill-color: #1a1a1a !important;
  text-decoration: none;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1px;

  /* Estética */
  box-shadow: 0 8px 20px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.5);
  border: 1px solid #8a6d3b;
  cursor: pointer;
  z-index: 99; /* Bien al frente */
  overflow: hidden;
  
  /* Evitamos que el navegador lo oculte antes de que GSAP actúe */
  opacity: 1; 
}

/* El destello mágico se mantiene igual */
.btn-rosa::after {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255,0.4), rgba(255,255,255,0));
  transform: skewX(-25deg);
}

.btn-rosa:hover::after {
  left: 150%;
  transition: all 0.6s ease;
}

/* ==================== LÍNEA VERTICAL ==================== */
.linea-wrapper{ height: 64px; display:flex; justify-content:center; align-items:flex-start; margin-top: 12px; }
.linea{
  width: 1px; height: 64px;
  background: linear-gradient(to bottom, #171717, #2a2929);
  transform: scaleY(1);
  will-change: transform;
}

/* ==================== RESPONSIVE ==================== */
@media (max-width: 380px){
  .titulo-script{ font-size: 32px; }
  .hora{ font-size: 22px; }
  .lugar{ font-size: 16px; }
}

/* Accesibilidad */
@media (prefers-reduced-motion: reduce){
  *{ transition: none !important; animation: none !important; }
}








/* ===== Escena final (degradado + flores) ===== */
.lux-escena-final{
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 8px;  
  margin-bottom: 50px;          /* pequeño respiro respecto a la tarjeta */
  overflow: visible;
}

.lux-degradado{
  width: 100%;
  height: 180px;              /* ajusta la altura del degradado a tu gusto */
  background: linear-gradient(
    to top,
    #f6d5e5 0%,               /* rosa baby base */
    rgba(246,213,229,0.85) 35%,
    rgba(246,213,229,0.35) 65%,
    rgba(246,213,229,0) 100%
  );
}

/* Flores pegadas al borde inferior con ligera sombra */
.lux-flores{
  position: absolute;
  bottom: -2px;               /* -2 para tocar el límite inferior visualmente */
  left: 50%;
  transform: translateX(-50%);
  width: min(760px, 110%);    /* ancho generoso estilo portada */
  max-width: 110%;
  pointer-events: none;
  filter: drop-shadow(0 8px 18px rgba(0,0,0,.08));
  opacity: 0.98;
}

</style>
